export interface SampleForValidation {
  sample_type_name: string;
  appointment_date?: string | null;
  appointment_time?: string | null;
  collection_date?: string | null;
  collection_time?: string | null;
  sent_date?: string | null;
  sent_time?: string | null;
  received_date?: string | null;
  received_time?: string | null;
  sample_data?: Record<string, any> | null;
}

export function getRequiredDateFields(sample: SampleForValidation): string[] {
  const missing: string[] = [];
  const type = sample.sample_type_name?.toLowerCase();

  if (type === 'urin' || type === 'kapillarblut' || type === 'schnelltest') {
    if (!sample.appointment_date) missing.push('Einbestellungsdatum');
    if (!sample.appointment_time) missing.push('Einbestellungszeit');
    if (!sample.collection_date) missing.push('Abgabedatum');
    if (!sample.collection_time) missing.push('Abgabezeit');
  } else if (type === 'haar') {
    if (!sample.collection_date) missing.push('Entnahmedatum');
    const hairLength =
      sample.sample_data?.hair_length ?? sample.sample_data?.hair_length_cm;
    if (hairLength === null || hairLength === undefined) {
      missing.push('Haarlänge');
    }
  } else {
    if (!sample.collection_date) missing.push('Abgabedatum');
    if (!sample.collection_time) missing.push('Abgabezeit');
  }

  return missing;
}

export function validateSampleForEvaluation(sample: SampleForValidation): string[] {
  const missing = getRequiredDateFields(sample);
  if (!sample.sent_date) missing.push('Versanddatum');
  if (!sample.sent_time) missing.push('Versandzeit');
  if (!sample.received_date) missing.push('Befunddatum');
  if (!sample.received_time) missing.push('Befundzeit');
  return missing;
}
